import { useNewerBuild } from "../updateCheck";

/**
 * The bar that says a newer Canopy is being served (punch list F173). Fixed
 * at the foot of the window, away from the header's controls; nothing
 * happens until **Reload** is pressed. Why and how: `updateCheck.ts`.
 */
export function UpdateBar() {
  const newer = useNewerBuild();
  if (!newer) return null;
  return (
    <div className="update-bar" role="status">
      <span>Canopy has been updated.</span>
      <button className="primary" onClick={() => window.location.reload()}>
        Reload
      </button>
    </div>
  );
}
